import { Button, Form, Input, Spin, message, DatePicker } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ReactQuill from 'react-quill';
import "react-quill/dist/quill.snow.css";
import dayjs from 'dayjs';

const UpdateBlogPage = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const params = useParams();
    const blogId = params.id;

    useEffect(() => {
        const fetchData = async () => {
          setLoading(true);
          try {
            const singleBlogResponse = await fetch(`${apiUrl}/api/blogs/${blogId}`);
      
            if (!singleBlogResponse.ok) {
              message.error("Veri Getirme Başarısız.");
              return;
            }
      
            const singleBlogData = await singleBlogResponse.json();
      
            if (singleBlogData) {
              const img = Array.isArray(singleBlogData.img) ? singleBlogData.img.join("\n") : "";
              const content = Array.isArray(singleBlogData.content) ? singleBlogData.content.join("\n") : "";
      
              form.setFieldsValue({
                name: singleBlogData.name,
                publishedDate: singleBlogData.publishedDate ? dayjs(singleBlogData.publishedDate) : null,
                description: singleBlogData.description,
                img: img,
                content: content,
              });
            }
          } catch (error) {
            console.log("Veri Hatası:", error);
            message.error("Veri Getirme İşlemi Sırasında Hata Oluştu.");
          } finally {
            setLoading(false);
          }
        };
        fetchData();
    }, [apiUrl, blogId, form]);
      
    const onFinish = async (values) => {
      const content = values.content ? values.content.split("\n").map((link) => link.trim()) : [];
    
      setLoading(true);
      try {
        const response = await fetch(`${apiUrl}/api/blogs/${blogId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...values,
            img: values.img.trim(),
            publishedDate: values.publishedDate.toISOString(),
          }),
        });
    
        if (response.ok) {
          message.success("Blog Başarıyla Güncellendi.");
          navigate("/admin/blogs"); // Bloglar admin sayfasına yönlendirme
        } else {
          const errorData = await response.json();
          message.error(`Blog Güncellenirken Hata: ${errorData.message}`);
        }
      } catch (error) {
        console.log("Blog Güncelleme Hatası:", error);
        message.error("Blog güncellenirken bir hata oluştu.");
      } finally {
        setLoading(false);
      }
    };
    
    return (
        <Spin spinning={loading}>
            <Form name="basic" layout="vertical" onFinish={onFinish} form={form}>
                <Form.Item
                    label="Blog Başlığı"
                    name="name"
                    rules={[{ required: true, message: "Lütfen Blog Adını Girin!" }]}>
                    <ReactQuill
                        theme="snow"
                        value={form.getFieldValue('name')}
                        onChange={(content) => form.setFieldsValue({ name: content })}
                        style={{ backgroundColor: "white" }}
                    />
                </Form.Item>

                <Form.Item
                    label="Yayın Tarihi"
                    name="publishedDate"
                    rules={[{ required: true, message: "Lütfen Bir Tarih Seçin!" }]}>
                    <DatePicker />
                </Form.Item>

                <Form.Item
                    label="Blog Açıklaması"
                    name="description"
                    rules={[{ required: true, message: "Lütfen Açıklama Girin!" }]}>
                    <ReactQuill theme="snow" style={{ backgroundColor: "white" }} />
                </Form.Item>

                <Form.Item
                    label="Blog Görselleri (Linkler)"
                    name="img"
                    rules={[{ required: true, message: "Lütfen Görsel Linki Girin!" }]}>
                    <Input.TextArea placeholder="Görsel Linkini Yazın." autoSize={{ minRows: 4 }} />
                </Form.Item>
                
                <Form.Item
                    label="Blog Yazısı"
                    name="content"
                    rules={[{ required: true, message: "Lütfen Blog Yazınızı Yazın!" }]}>
                    <ReactQuill theme="snow" style={{ backgroundColor: "white" }} />
                </Form.Item>
                
                <Button type="primary" htmlType="submit">Güncelle</Button>
            </Form>
        </Spin>
    );
};

export default UpdateBlogPage;
